import React, { Fragment } from 'react'
import { NavLink, Link } from 'react-router-dom'
import FooterArea from '../../../components/FooterArea'

import AllLawDocsArea from '../../../components/allLawDocs'
import './style.scss'
const AllLawDocsAreaPage = () => {
    const [readMore, setReadMore] = React.useState(true);
    return (
        <Fragment>
            
           <AllLawDocsArea
           className="SignInArea"
            />
            <FooterArea/>
        </Fragment>
    )
}
export default AllLawDocsAreaPage
/* AddLawDocs */